import { render, staticRenderFns } from "./budgetDetail.vue?vue&type=template&id=38866855&scoped=true&"
import script from "./budgetDetail.vue?vue&type=script&lang=js&"
export * from "./budgetDetail.vue?vue&type=script&lang=js&"
import style0 from "./budgetDetail.vue?vue&type=style&index=0&id=38866855&scoped=true&lang=css&"
import style1 from "./budgetDetail.vue?vue&type=style&index=1&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "38866855",
  null
  
)

export default component.exports